import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import StartingChainCalculator from './components/startingChainCalculator';
import HSTTool from './components/hstTool';
import CrochetStudioAd from './components/crochetStudioAd';

const startingChainContainer = [...document.querySelectorAll('div>pre')]
  .find(
    (preEle) => preEle.textContent === 'daryl-and-james:tool#starting-chain-calculator'
  )?.parentElement;

if (startingChainContainer) {
  const startingChain = ReactDOM.createRoot(
    startingChainContainer as HTMLElement
  );
  startingChain.render(
    <React.StrictMode>
      <StartingChainCalculator />
    </React.StrictMode>
  );
}

const hstToolContainer = [...document.querySelectorAll('div>pre')]
  .find(
    (preEle) => preEle.textContent === 'daryl-and-james:tool#hst-tool'
  )?.parentElement;

if (hstToolContainer) {
  const hstTool = ReactDOM.createRoot(
    hstToolContainer as HTMLElement
  );
  hstTool.render(
    <React.StrictMode>
      <HSTTool />
    </React.StrictMode>
  );
}

const CrochetStudioAdContainer = [...document.querySelectorAll('div>pre')]
  .find(
    (preEle) => preEle.textContent === 'daryl-and-james:tool#crochet-studio'
  )?.parentElement;

if (CrochetStudioAdContainer) {
  const CrochetStudioAdSpot = ReactDOM.createRoot(
    CrochetStudioAdContainer as HTMLElement
  );
  CrochetStudioAdSpot.render(
    <React.StrictMode>
      <CrochetStudioAd />
    </React.StrictMode>
  );
}

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
